import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class MVRReport extends AbstractModel {
  @autoserialize
  mvrId: string;

  @autoserialize
  score: number;

  @autoserialize
  screeningId: number;

  @autoserialize
  error: string;

  @autoserializeAs(Date)
  mvrDateTime: Date;

  public static OnSerialized(instance: MVRReport, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.mvrDateTime)) {
      json.mvrDateTime = DateUtil.serializeDate(instance.mvrDateTime);
    }
  }
}
